<template>
  <div>
    <div
      style="
        background-size: cover;
        color: #fff;
        position: fixed;
        width: 100%;
        top: 0px;
      "
      :style="{ backgroundImage: `url(${backgroundBanner})` }"
      class="d-none d-sm-flex"
    >
      <div style="width: 100%" class="mt-5 m-0">
        <h3 class="text-center text-white m-0">Accepting Request</h3>
        <br /><br />
      </div>
    </div>
    <div
      style="
        background-size: cover;
        color: #fff;
        position: fixed;
        width: 100%;
        top: 0px;
      "
      :style="{ backgroundImage: `url(${backgroundBanner})` }"
      class="d-flex d-sm-none"
    >
      <div class="mt-5"><br /><br /><br /><br /><br /></div>
    </div>
    <CCard class="custom-card h-100">
      <CCol sm="12" class="justify-content-center m-0">
        <CContainer>
          <CCol sm="12" lg="12" class="custom-margin m-0 p-0">
            <h5 class="text-left mt-2 d-flex d-sm-none text-black bold">
              Accepting Request <br />
            </h5>

            <CCard v-if="!profiles.length">
              <div class="mt-5 text-center mb-5">
              <img src="../assets/img/nodata.png" width="120px"/>
              <br />
              No Accepting Yet
              </div>
            </CCard>

          
            <CCard v-else
              v-for="(item, index) in profiles"
              v-bind:key="item.Id"
              class="p-2 mt-2"
            >
           
              <CCol>
                <CRow
                  @click="GoToPageNotification(index)"
                  sm="10"
                  lg="10"
                  class="mx-auto d-flex justify-content-center"
                >
                  
                  <CCol sm="12" lg="12">
                    <CRow>
                      <CCol sm="12" lg="12">
                    
                       Find Tutor
                        <br />
                       <strong>{{ item.Count }} tutors </strong> want to be your class tutor.Please respond this application immediately.Select one tutor only.
                          <br />  <br />
                         
                          <label><strong> Subject:</strong> {{ item.TeacherId.Subject }}</label>
                          <br />
                           <label><strong> Level:</strong> {{ item.TeacherId.Level }}</label>
                        <br />
                      </CCol>
                      
                    </CRow>
                  </CCol>
                </CRow>
              </CCol>
            </CCard>

           
          </CCol>
        </CContainer>
      </CCol>
    </CCard>
  </div>
</template>


<script>
import backgroundBanner from "../assets/img/bgApps.jpg";
export default {
  name: "Login",
  data() {
    return {
      backgroundBanner,
      profiles: [],
    };
  },
  async mounted() {
    await this.GetRequest();
  },
  methods: {
    async GetRequest() {
      this.$API
        .get(this.$Request + "?userId=" + this.$route.query.userId, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.profiles = response.data;
          }
        });
    },

    GoToPageNotification(index) {
      this.$router.push(
        "/NotificationStudent?userId=" + this.$route.query.userId + "&subjectId=" + this.profiles[index].TeacherId.SubjectId + "&levelId=" + this.profiles[index].TeacherId.LevelId
      );
    },
  },
};
</script>
